export default function (str, sep=' ') {
  if (!str) return ''
  return str.toLowerCase().split(sep).map(function(word) {
    return (word.charAt(0).toUpperCase() + word.slice(1));
  }).join(' ');
}
